import { DashboardModule, Link } from '@domain-group/suit-theme'

import type { TaskListItemModel } from '@models/types'

import useTaskListItem, { useRelations } from '@hooks/useTaskListItem'
import useTaskLists from '@hooks/useTaskLists'

import Checklist from './Checklist'

interface ChecklistsProps {
  taskListItem: TaskListItemModel,
}

const Checklists = (props: ChecklistsProps) => {
  const { taskListItem } = props

  const { checklistTemplate } = useRelations(taskListItem)

  const taskListItemPayload = useTaskListItem(taskListItem)
  const { callbacks: { viewChecklistTemplate } } = taskListItemPayload

  const taskListsPayload = useTaskLists({
    filters: {
      subject_type: 'TaskListItem',
      subject_id: taskListItem.id,
      template_checklist: true,
    },
    performHttpRequests: !!taskListItem.id,
  })

  const { filteredTaskLists, hasFilteredTaskLists, loading } = taskListsPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      // @ts-expect-error TS2339
      headerRight={!!checklistTemplate.id && (
        <Link onClick={() => viewChecklistTemplate()} textProps={{ fontSize: 'small' }}>
          View Template
        </Link>
      )}
      title="Checklists"
    >
      {!loading && !hasFilteredTaskLists && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>No Checklists created yet</DashboardModule.BlankState.Title>
          <DashboardModule.BlankState.Paragraph>
            They will be created when build tasks are completed.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {filteredTaskLists.map(taskList => (
        <Checklist key={taskList.id} taskList={taskList} />
      ))}
    </DashboardModule>
  )
}

export default Checklists
